import { UrlSearchParamsIe } from '../polyfill/UrlSearchParams'

export const getSessionIdFromSearchString = (search) => {
  if (search) {
    if ('URLSearchParams' in window) {
      const params = new URLSearchParams(search)
      const sessionId = params.get('sessionId')
      return sessionId
    } else {
      const params = UrlSearchParamsIe(search)
      return params.sessionId
    }
  } else return null
}



// WEBPACK FOOTER //
// ./src/util/UrlSearchParams.js